export { default as NewspaperSolidIcon } from './NewspaperSolidIcon';
